import { CurrencyCode } from 'further-types/lp/vehicle';
import FormWrapper, {
  EqualisationGeneralCapitalCallsFormValues,
} from './FormWrapper';
import GeneralCapitalCallsContent from './GeneralCapitalCallsContent';
import { EqualisationSection } from 'further-types/lp/equalisation';
import { useParams } from 'react-router-dom';
import api from 'lib/trpcClient';
import { useLayoutContext } from 'contexts/LayoutContext';

const EqualiseGeneralCapitalCalls: React.FC<{ baseCurrency: CurrencyCode }> = ({
  baseCurrency,
}) => {
  const { id } = useParams<{ id?: string }>();
  const { selectedVehicleId } = useLayoutContext();
  const [generalCapitalCalls] =
    api.equalisations.getEqualisationGeneralCapitalCalls.useSuspenseQuery({
      vehicleId: selectedVehicleId ?? '',
      equalisationId: id ?? '',
    });

  const formValues: EqualisationGeneralCapitalCallsFormValues = {
    generalCapitalCalls: generalCapitalCalls.map((generalCapitalCall) => ({
      actionId: generalCapitalCall.actionId,
      entryId: generalCapitalCall.entryId,
      name: generalCapitalCall.name,
      allocationRule: generalCapitalCall.allocationRule,
      ledgerDate: generalCapitalCall.ledgerDate,
      actionDueDate: generalCapitalCall.actionDueDate,
      totalAmountLcy: generalCapitalCall.totalAmountLcy,
      originalInvestorBreakdown: generalCapitalCall.originalInvestorBreakdown,
      newInvestorBreakdown: generalCapitalCall.newInvestorBreakdown,
      numberOfEntries: generalCapitalCall.numberOfEntries,
    })),
  };

  return (
    <FormWrapper
      key={EqualisationSection.GeneralCapitalCalls}
      values={formValues}
    >
      <GeneralCapitalCallsContent baseCurrency={baseCurrency} />
    </FormWrapper>
  );
};

export default EqualiseGeneralCapitalCalls;
